import { consumer, IResponse, API, ICertificate, postFile } from "@bemap/utils";

const ENDPOINT = '/certificates'

export const getCertificates = async (): Promise<IResponse> => {
  return consumer('GET', ENDPOINT);
}

export const getCertificate = async (id: number): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, id);
}

export async function newCertificate(payload: ICertificate): Promise<IResponse> {
  return consumer('POST', `${ENDPOINT}/batch`, payload);
}

export const updateCertificate = async (payload: Partial<ICertificate>): Promise<IResponse> => {
  return consumer('PATCH', ENDPOINT, payload, payload.id);
}

export const generateCertificate = async (id: number): Promise<IResponse> => {
  return consumer('POST', ENDPOINT, undefined, `${id}/generate`);
}

export const getCertificateUrl = async (id: number): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, `${id}/download`);
}

export async function deleteCertificate(id: number): Promise<IResponse> {
  return consumer('DELETE', ENDPOINT, undefined, id);
}

export async function batchCertificate(payload: FormData): Promise<IResponse> {
  return postFile(`/certificates/batch`, payload);
}

export const batchDownload = async (keys: string[]): Promise<Blob> => {
  const url = `/certificates/batch-download`
  try {
    const response = await API.post(url, { keys }, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' }
    });

    return response.data;
  } catch (error: any) {
    const { message, statusCode } = error.response.data;
    throw {
      statusCode,
      message
    }
  }
}